// organisms/ModalMenuItems/ModalMenuItems.tsx
import React from 'react';
import { List, ListItem } from '@mui/material';
import { ModalMenuItem, type ModalMenuItemProps } from '../../molecules/ModalMenuItem';

export interface ModalMenuItemsProps {
    menuItems: ModalMenuItemProps[];
    folded?: boolean;
    onSidebarClose?: () => void;
}

/**
 * Container pour les MenuItems en mode modal
 * Utilise le contexte fourni par le composant parent
 */
export const ModalMenuItems: React.FunctionComponent<ModalMenuItemsProps> = function ({
    menuItems,
    folded = false,
    onSidebarClose = undefined,
}) {
    return (
        <List
            className="modal-menu-items"
            data-testid="modal-menu-items"
        >
            {menuItems.map((item) => (
                <ListItem
                    key={`modal-menu-item-${item.identifier}`}
                    sx={
                        folded
                            ? {
                                  borderTop: '1px dashed',
                                  borderColor: 'grey.300',
                              }
                            : {}
                    }
                >
                    <ModalMenuItem
                        {...item}
                        onSidebarClose={onSidebarClose}
                        folded={folded}
                    />
                </ListItem>
            ))}
        </List>
    );
};
